export const LICENSE_KEY =
    "eaa04298c880ee5a01c3c1f8ecfc8314Tz04ODc1OSxFPTE3NDUwOTA4NjcwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=";
export const GOOGLE_MAP_KEY = "AIzaSyA3CvTeFPuHo7ePjm5YOva66gR-pFWZvPc";
export const X_API_KEY = "69e5ca40-0dbb-4ba3-a008-98a702990564";
export const APLICACION_COD = "MIAWEBCLI";
export const FALLBACK_URL = "https://acceso.hooli.la";
